/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import VirtualAgentLandingPageQuery from './__generated__/VirtualAgentLandingPageQuery$parameters';
import type { VirtualAgentLandingPageQuery as VirtualAgentLandingPageQueryType } from './__generated__/VirtualAgentLandingPageQuery.graphql';

const DEFAULT_TIME_RANGE_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

const formatFetchDate = (date: Date) => date.toISOString().substring(0, 10); // has to be truncated for proper caching in SSR

type LandingEntryPointComponent = EntryPointComponent<
	{
		page: VirtualAgentLandingPageQueryType;
	},
	{},
	{},
	{} | null
>;

export const landingEntryPoint: EntryPoint<LandingEntryPointComponent, EntryPointRouteParams> =
	createEntryPoint({
		root: JSResourceForInteraction<LandingEntryPointComponent>(
			/* webpackChunkName: "async-virtual-agent-landing" */ './VirtualAgentLandingPage.tsx',
		),
		getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
			queries: {
				page: {
					parameters: VirtualAgentLandingPageQuery,
					variables: {
						cloudId: tenantContext.cloudId,
						projectKey: context.match.params.projectKey ?? '',
						startDate: formatFetchDate(new Date(Date.now() - DEFAULT_TIME_RANGE_MS)),
						endDate: formatFetchDate(new Date()),
					},
				},
			},
		}),
	});
